"use strict";
/**
|--------------------------------------------------
| If jQuery is available in the window object it will be used.
| If not, it will attempt to load jQuery from the CDN.
| If it fails, use the local version of jQuery.
|--------------------------------------------------
*/

export const initJquery = async () => {
    if(window.$) {
        // console.log("jQuery is already loaded in the window object.");
        return;
    }
    if(window.jQuery) {
        window.$ = window.jQuery
        // console.log("jQuery is already loaded in the window object.");
        return;
    }
    try {
        await import('https://code.jquery.com/jquery-3.7.1.min.js');
        // console.log("jQuery loaded from CDN");
    } catch (error) {
        console.error("Failed to load jQuery dynamically from CDN:", error);
        try {
            const localModule = await import('../../jquery.min.js');
            window.jQuery = localModule.default;
            window.$ = localModule.default;
            console.log("jQuery loaded from local version");
        } catch (localError) {
            console.error("Failed to load local jQuery version:", localError);
        }
        return;
    }
}